import { get } from "svelte/store";

export const completeValidation = async (form, formStore) => {
  form.markDirty();
  form.validate();

  const pendingValidation = () => {
    return Object.keys(formStore.fields).some(fieldName => {
      return formStore.fields[fieldName].pending;
    });
  };

  while (pendingValidation()) {
    await new Promise(resolve => setTimeout(resolve, 1));
  }
};

export const markDirty = field => {
  let fieldStore = get(field);
  field.set(fieldStore, true);
};
